import { createFileRoute } from "@tanstack/react-router";
import { AdminHallOfFameTab } from "@/components/admin/AdminHallOfFameTab";

export const Route = createFileRoute("/_authenticated/admin/hall-of-fame")({
  head: () => ({ meta: [{ title: "Hall of Fame — Admin" }] }),
  component: AdminHallOfFamePage,
});

function AdminHallOfFamePage() {
  return <AdminHallOfFameTab />;
}
